/* tslint:disable */
/* eslint-disable */
/**
 * Melco Tracking APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrackingMelcoAnalyticsModelsAvailabilityAppListItem
 */
export interface TrackingMelcoAnalyticsModelsAvailabilityAppListItem {
    /**
     * 
     * @type {string}
     * @memberof TrackingMelcoAnalyticsModelsAvailabilityAppListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingMelcoAnalyticsModelsAvailabilityAppListItem
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingMelcoAnalyticsModelsAvailabilityAppListItem
     */
    app_name?: string | null;
}

export function TrackingMelcoAnalyticsModelsAvailabilityAppListItemFromJSON(json: any): TrackingMelcoAnalyticsModelsAvailabilityAppListItem {
    return TrackingMelcoAnalyticsModelsAvailabilityAppListItemFromJSONTyped(json, false);
}

export function TrackingMelcoAnalyticsModelsAvailabilityAppListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingMelcoAnalyticsModelsAvailabilityAppListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'app_name': !exists(json, 'app_name') ? undefined : json['app_name'],
    };
}

export function TrackingMelcoAnalyticsModelsAvailabilityAppListItemToJSON(value?: TrackingMelcoAnalyticsModelsAvailabilityAppListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'description': value.description,
        'app_name': value.app_name,
    };
}


